import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { MarineApiService } from 'src/app/core/services/api/marine-api.service';
import { Ship } from '../../models/data/ship';


@Component({
  selector: 'app-ships-create-edit',
  templateUrl: './ships-create-edit.component.html',
  styleUrls: ['./ships-create-edit.component.scss']
})
export class ShipsCreateEditComponent implements OnInit {
  public ship: Ship;

  @ViewChild('shipsModal') shipsModal;
  @Output() submit: EventEmitter<Ship> = new EventEmitter<Ship>();

  modalRef: NgbModalRef;

  constructor(private modalService: NgbModal,
    private api: MarineApiService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
  }

  // handle the popup
  open(ship: Ship) {
    this.ship = Object.assign(new Ship(), ship);
    this.modalRef = this.modalService.open(this.shipsModal, { centered: true, size: 'lg' });
  }

  close() {
    this.modalRef.close();
  }

  onSubmit() {
    if (this.ship.id) {
      this.spinner.show();
      this.api.updateShip(this.ship).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
        }
      )
    } else {
      this.spinner.show();
      this.api.createShip(this.ship).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
        }
      )
    }
  }

}

